module.exports = __webpack_public_path__ + "static/media/texture_cinderblock_pattern_tile.b05325e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/texture_cinderblock_pattern_tile.jpg
// module id = 491
// module chunks = 0